/* tslint:disable:max-line-length */
import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
// import {  } from '@fortawesome/pro-light-svg-icons';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { faHamburger, faSearch, faTimes, faBars, faMapMarkerAlt, faListUl, faClock, faLongArrowAltRight, faInfoCircle, faPlus, faMinus, faMap, faChargingStation, faShuttleVan, faBicycle } from '@fortawesome/pro-regular-svg-icons';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faHamburger, faSearch, faFacebookF, faTwitter, faTimes, faBars, faMapMarkerAlt, faListUl, faClock, faLongArrowAltRight, faInfoCircle, faPlus, faMinus, faMap, faChargingStation, faShuttleVan, faBicycle, faExclamationCircle);

Vue.component('fa-icon', FontAwesomeIcon);
/* tslint:enable:max-line-length */
